<template>
  <div class="vx-row mb-2 mt-1">
    <div class="vx-col w-full">
      <span class="text-xs">{{ fieldLabel }}</span>
      <br />
      <vs-button id="fileLoader" @click="triggerUpload()" class="mr-10"
        >Upload Images</vs-button
      >
      <br />
      <div v-for="(val, index) in tempFiles" :key="index">
        <div class="container">
          <img style="height: 100px; width: auto" :src="imgSrc(val)" />
          <vs-button
            class="btndelete btn-danger"
            @click.stop="tempFiles.splice(index, 1)"
            >X</vs-button
          >
        </div>
      </div>

      <form
        style="display: none"
        method="post"
        action="#"
        id=""
        enctype="multipart/form-data"
      >
        <div class="form-group files text-center" ref="fileform">
          <input
            type="file"
            ref="file"
            multiple="multiple"
            @change="uploadFiles"
          />
          <span id="val"></span>
          <a class="btn" @click="submitFiles()" id="button">Upload Photo</a>
        </div>
      </form>
      <!-- <vs-upload
        automatic
        name="file"
        :limit="structure.fileLimit"
        fileName="file"
        text="Muat Naik"
        :action="uploadUrl"
        @on-success="successUpload"
        multiple="false"
        :headers="headers"
      /> -->
    </div>
  </div>
</template> 
<script>
import { sidebarMixin } from "../sidebarMixin";
import { alertMixin } from "../../../mixin/alertMixin";
import axios from "@/axios.js";
export default {
  mixins: [sidebarMixin, alertMixin],

  props: {
    baseUrl: String,
    uploadEndpoint: String,
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
  },

  data() {
    return {
      localVal: "",
      name: "",
      tempFiles: [],
    };
  },

  computed: {
    uploadUrl() {
      return this.baseUrl + this.uploadEndpoint;
    },
    baseURl() {
      return axios.defaults.baseURL;
    },
  },

  watch: {
    tempFiles: function (value) {
      value = value.toString("|");
      console.log("File total input: ", value);
      this.$emit("input", {
        index: this.index,
        value: value.replace('"', "").replace('"', ""),
      });
      this.$emit("error", { index: this.index, value: true });
    },
  },

  methods: {
    imgSrc(src) {
      return this.baseURl + "/storage/" + src;
    },
    triggerUpload() {
      this.$refs.file.click();
    },
    uploadFiles() {
      console.log("old:", this.tempFiles.length);
      console.log("new:", this.$refs.file.files.length);
      console.log(
        "total:",
        this.$refs.file.files.length + this.tempFiles.length
      );
      console.log(" this.structure.fileLimit:", this.structure.fileLimit);
      if (
        this.$refs.file.files.length + this.tempFiles.length <=
        this.structure.fileLimit
      ) {
        let formData = new FormData();

        for (var i = 0; i < this.$refs.file.files.length; i++) {
          let file = this.$refs.file.files[i];
          formData.append("files[" + i + "]", file);
        }

        //formData.append("files", this.$refs.file.files[0]);
        this.startLoading();
        var that = this;
        axios
          .post(this.uploadUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            response.data.forEach((element) => {
              this.tempFiles.push(element);
            });

            console.log(" this.tempFiles:", this.tempFiles);
            that.closeLoading();
          })
          .catch(function () {
            that.closeLoading();
          }); 
      } else {
        this.errorAlert(
          "Maksimum Limit",
          "Maksimum " + this.structure.fileLimit + " gambar sahaja"
        );
      }
    },
    startLoading() {
      this.$vs.loading({
        container: "#fileLoader",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#fileLoader > .con-vs-loading");
    },
    successUpload(event) {
      if (this.localVal == "") {
        this.localVal = event.currentTarget.response;
      } else {
        this.localVal = this.localVal + "|" + event.currentTarget.response;
      }
    },
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.$emit("error", { index: this.index, value: true });
      this.$emit("input", { index: this.index, value: file });
    },
  },

  created() {
    this.$emit("error", { index: this.index, value: true });
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    this.localVal = this.value;

    this.tempFiles = this.value.split(",");

    // this.$watch("tempFiles", (value) => {

    // });
  },

  created() {
    this.$emit("error", { index: this.index, value: true });
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    this.localVal = this.value;

    this.tempFiles = this.value.split(",");

    // this.$watch("tempFiles", (value) => {

    // });
  }
};
</script> 

<style lang="css" >
/* Container needed to position the button. Adjust the width as needed */
.container {
  position: relative;
  width: 50%;
}

/* Make the image responsive */
.container img {
  width: 100%;
  height: auto;
}

/* Style the button and place it in the middle of the container/image */
.container .btndelete {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.container .btn:hover {
  background-color: red;
}
</style>